import { correctImageOrientation } from '@gaoding/editor-utils/correct-image-orientation';
import { Message } from '@gaoding/gdui';
import { uniq } from 'lodash';
import Promise from 'bluebird'

import imageResizer from './image-resizer';
import {MIME_TO_EXT_MAP, EXT_TO_MIME_MAP } from './file-format';
import { loadResourceByFile } from './load-resource';


const ImageEditorTypes = 'jpg,jpeg,png';

const imageOptions = {
    maxWidth: 5000,
    maxHeight: 5000,
    minWidth: 20,
    minHeight: 20,
    maxCount: 1
};

const filterFiles = (files, filter, errorMsg) => {
    const length = files.length;
    files = files.filter(filter);
    if(files.length !== length && errorMsg) {
        Message.error(errorMsg);
    }
    return files;
};

export function validateImageFilesType(files, types = DEFAULT_TYPES, showErrTips = true) {
    // @TODO: 兼容字符串格式 jpg -> ['image/jpg']
    if(typeof types === 'string') {
        types = types.split(',').map(t => EXT_TO_MIME_MAP[t]);
    }

    files = Array.from(files).filter(file => file);
    const exts = uniq(types.map(t => MIME_TO_EXT_MAP[t]));

    const isTypeSupported = file => types.includes(file.type);

    files = filterFiles(files, isTypeSupported, showErrTips ? `仅支持${exts.join('/').toUpperCase()}格式素材` : '');

    return files;
}

export async function validateTypeAndCount(files, options = {}) {
    options = Object.assign(imageOptions, options);
    const { maxCount } = options;

    const length = files.length;
    const isCountValid = length <= maxCount;

    files = validateImageFilesType(files, ImageEditorTypes, false);

    const isAllTypeSupported = files.length === length;

    const exts = ImageEditorTypes.split(',');

    if(!isAllTypeSupported || !isCountValid) {
        let errTips = `仅支持${isCountValid ? '' : '最多上传' + maxCount + '张'}${isAllTypeSupported ? '' : `${exts.join('/').toUpperCase()}格式的`}图片`;
        if(!files.length) {
            errTips += ',请重新上传';
        }
        Message.error(errTips);
        throw new Error('format error');
    }

    files = files.splice(0, maxCount);

    return files;
}

function resizeImages(files, options) {
    const { maxWidth, maxHeight, minWidth, minHeight } = options;
    return Promise.all(files.map(async(file, idx) => {
        const { info = {} } = file;
        const { width, height } = info;
        if(width > maxWidth ||
            height > maxHeight ||
            width < minWidth ||
            height < minHeight) {
            const [ w, h ] = imageResizer.getResizeSize(width, height, options) || [width, height];
            if(w !== width || h !== height) {
                file = await imageResizer.resizeImageByFile(file, {
                    type: file.type.split('/').pop(),
                    quality: 0.92,
                    width: w,
                    height: h
                });

                file.info = Object.assign({}, info, {
                    width: w,
                    height: h
                });
            }
        }

        return file;
    }));
};

export async function correctAndResizeFiles(files, options = {}) {
    options = Object.assign(imageOptions, options);
    files = await Promise.all(files.map(correctImageOrientation));
    try { 
        files = await resizeImages(files, options);
    } catch(err) {
        if (err.message === 'too small') {
            Message.error('仅支持上传大于20px x 20px的图片')
        }
        throw err;
    }

    return files;
}

export async function setResourceInfo(files) {
    try {
        const resourceElems = await Promise.all(files.map(loadResourceByFile));

        return Promise.map(files, async(file, idx) => {
            file.info = file.info || {};
            Object.assign(file.info, {
                url: resourceElems[idx].src,
                width: resourceElems[idx].width,
                height: resourceElems[idx].height,
            });
        });
    }
    catch(e) {
        Message.error(e.message);
        throw e;
    }
};


export const  validateFiles = async (files) => {
    if(!files || !files.length) {
        return files;
    }
    files.map((file) => {
        if (file.size > 12 * 1024 * 1024) {
            Message.error('仅支持12M以下的JPG/PNG/JPEG图片');
            throw new Error('size overflow')
        }
    })
    await setResourceInfo(files)
    files = await validateTypeAndCount(files);
    if(!files.length) {
        return [];
    }
    files = await correctAndResizeFiles(files);
    return files;
}
